import { global_shoppable_editorial } from '../../utils/requests/contentstack/contentStackZodSchema';
import { getCloudinaryImageFields } from '../../utils/getCloudinaryItem/getCloudinaryItem';
import type { ShoppableEditorialProps } from './ShoppableEditorial';
export const shoppableEditorialSchema = global_shoppable_editorial.transform<ShoppableEditorialProps>(data => ({
  title: data.title,
  description: data.description,
  coverItem: {
    brand: data.cover_item.product_brand,
    href: data.cover_item.href?.href,
    image: getCloudinaryImageFields({
      alt: data.cover_item.image.alt,
      cloudinaryField: data.cover_item.image.src,
      shouldUseV2: true
    }),
    name: data.cover_item.product_name,
    price: data.cover_item.product_price
  },
  items: data.items.map(item => ({
    brand: item.product_brand,
    href: item.href?.href,
    image: getCloudinaryImageFields({
      alt: item.image.alt,
      cloudinaryField: item.image.src,
      shouldUseV2: true
    }),
    name: item.product_name,
    price: item.product_price
  }))
}));